<template>
  <div>
    <v-container>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <v-layout row wrap>
          <v-flex md6 pa-2>
            <h3 class="headline">Thống kê trong ngày</h3>
            <p class="statistic first">Bắt đầu di chuyển lúc: {{todayReporting.start}}</p>
            <p class="statistic">Tổng thời gian di chuyển: {{todayReporting.move}}</p>
            <p class="statistic">Tổng thời gian dừng: {{todayReporting.idle}}</p>
            <p class="statistic">Quãng đường di chuyển: {{todayReporting.total}} km</p>
          </v-flex>
          <v-flex md6 pa-2>
            <h4 class="headline">Thông tin thiết bị</h4>
            <p class="statistic first">Loại thiết bị: {{selectedVehicle.deviceType}}</p>
            <p class="statistic">Số IMEI: {{selectedVehicle.imei}}</p>
            <p class="statistic">SĐT Sim: {{selectedVehicle.simPhone}}</p>
            <p
              class="statistic"
            >Gói cước: {{selectedVehicle.planCode ? selectedVehicle.planCode : 'Unknow'}}, kích hoạt: {{activateDate}}</p>
            
            <v-switch 
              v-model="cutOffEngine"
              @change="updateCutOffEngineData"
              label="Cho phép tắt động cơ từ xa" 
              input-value="true" 
              class="mt-0 switch-engine"
              color="primary"
              v-if="selectedVehicle.deviceType === 'MT20' || selectedVehicle.deviceType === 'MT30' || selectedVehicle.deviceType === 'MT20P'"
            />
          </v-flex>
        </v-layout>
        <br>
        <v-divider v-show="!selectedVehicle.isLocked"></v-divider>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 v-show="!selectedVehicle.isLocked">
        <h3 class="headline top">Quản lý xe</h3>
        <v-layout row wrap>
          <template v-for="(item, index) in buttons.vehicle" >
            <v-flex xs4 sm4 md4 lg4 xl4 :key="index" v-if="showButton(item)">
              <button-card
                :color="item.color"
                :icon="item.icon"
                :text="item.text"
                :onClick="item.click"
                class="btn-card"
              />
            </v-flex>
          </template>
        </v-layout>
        <br>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 v-show="!selectedVehicle.isLocked">
        <h3 class="headline top">Báo cáo thống kê</h3>
        <v-layout row wrap>
          <v-flex xs4 sm4 md4 lg4 xl4 v-for="(item, index) in buttons.reporting" :key="index">
            <button-card
              :color="item.color"
              :icon="item.icon"
              :text="item.text"
              :onClick="item.click"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
    <div class="text-xs-center">
      <v-dialog v-model="securityConfigDialog" width="360">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>{{selectedVehicle.plate}} - Thiết lập chống trộm</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="securityConfigDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <security-config @show="securityConfigDialog = $event"/>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editVehicleDialog" width="360">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>{{selectedVehicle.plate}} - Chỉnh sửa thông tin</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="editVehicleDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <edit-vehicle @show="editVehicleDialog = $event"/>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteVehicleDialog" width="360">
        <v-card>
          <v-card-title class="headline">Xóa xe {{selectedVehicle.plate}}?</v-card-title>
          <v-card-text>
            <span
              class="red--text"
            >Lưu ý: bạn nên lưu lại số IMEI và số điện thoại sim của thiết bị để sử dụng lại khi cần</span>
            <br>
            Imei: {{selectedVehicle.imei}}
            <br>
            Số điện thoại sim: {{selectedVehicle.simPhone}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="deleteVehicleDialog = false">Hủy</v-btn>
            <v-btn color="red" flat="flat" :loading="isLoading" @click="deleteSubmit()">Xóa</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <share-vehicle ref="shareVehicle"/>
      <interval-send-data ref="intervalSendData"/>
    </div>
  </div>
</template>
<script>
import ButtonCard from '@/components/widgets/card/buttoncard';
import SecurityConfig from './SecurityConfig';
import EditVehicle from './edit';
import ShareVehicle from './share';
import IntervalSendData from './IntervalSendData';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  name: 'vehicle-security-config',
  components: {
    ButtonCard,
    SecurityConfig,
    EditVehicle,
    ShareVehicle,
    IntervalSendData
  },

  data () {
    return {
      securityConfigDialog: false,
      editVehicleDialog: false,
      deleteVehicleDialog: false,
      isLoading: false,
      buttons: {
        vehicle: [
          {
            text: 'Thiết lập chống trộm',
            icon: 'security',
            color: 'orange',
            click: _ => {
              this.securityConfigDialog = true;
            }
          },
          {
            text: 'Bảo trì - bảo dưỡng',
            icon: 'build',
            color: 'pink',
            click: _ => {
              window.location.href = `#/maintenance?vehicleId=${
                this.selectedVehicle.id
              }`;
            }
          },
          {
            text: 'Khởi động lại thiết bị',
            icon: 'replay',
            color: 'teal',
            to: '',
            click: _ => {
              this.rebootDevice(this.selectedVehicle.id)
                .then(_ => {
                  window.getApp.showMessage('Gửi lệnh đến thiết bị thành công');
                })
                .catch(_ => {
                  window.getApp.showMessage(
                    'Gửi lệnh đến thiết bị thất bại',
                    'error'
                  );
                });
            }
          },
          {
            text: 'Chia sẻ lộ trình',
            icon: 'share',
            color: 'purple',
            click: _ => this.openShareVehicle()
          },
          {
            text: 'Chỉnh sửa',
            icon: 'edit',
            color: 'light-blue',
            click: _ => {
              this.editVehicleDialog = true;
            }
          },
          {
            text: 'Tần suất gửi dữ liệu',
            icon: 'watch_later',
            color: 'indigo',
            click: _ => this.openIntervalSendData()
          },
          {
            text: 'Xóa',
            icon: 'delete_forever',
            color: 'red',
            click: _ => {
              this.deleteVehicleDialog = true;
            }
          }
        ],
        reporting: [
          {
            text: 'Quãng đường theo xe',
            icon: 'show_chart',
            color: 'grey',
            to: '',
            click: _ => {
              window.location.href = '#/reporting/dailybyvehicle';
            }
          }
        ],
        device: [
          {
            text: 'Khởi động lại thiết bị',
            icon: 'replay',
            color: 'teal',
            to: '',
            click: _ => {}
          }
        ]
      },

      cutOffEngine: false
    };
  },

  computed: {
    ...mapGetters(['selectedVehicle']),
    todayReporting () {
      return {
        start: DateTimeUtil.formatSecondToHHmm(
          this.selectedVehicle.waypoint
            ? this.selectedVehicle.waypoint.dayState.startTime
            : 0
        ),
        move: DateTimeUtil.formatSecondToDuration(
          this.selectedVehicle.waypoint
            ? this.selectedVehicle.waypoint.dayState.runSeconds
            : 0
        ),
        idle: DateTimeUtil.formatSecondToDuration(
          this.selectedVehicle.waypoint
            ? this.selectedVehicle.waypoint.dayState.idleSeconds
            : 0
        ),
        total: this.selectedVehicle.waypoint
          ? this.selectedVehicle.waypoint.dayState.km.toFixed(2)
          : 0
      };
    },
    activateDate () {
      return DateTimeUtil.formatSecondToYYMMDD(
        this.selectedVehicle.activatedDate
      );
    }
  },

  watch: {
    selectedVehicle () {
      this.cutOffEngine = this.selectedVehicle.cutOffEngine;
    }
  },

  created () {
    this.cutOffEngine = this.selectedVehicle.cutOffEngine;
  },

  methods: {
    ...mapActions(['rebootDevice', 'deleteVehicle', 'updateCutOffEngine', 'getVehicles']),
    deleteSubmit () {
      this.isLoading = true;
      this.deleteVehicle(this.selectedVehicle.id)
        .then(_ => {
          this.isLoading = false;
          this.deleteVehicleDialog = false;
          window.getApp.showMessage('Xóa xe thành công');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(_ => {
          this.isLoading = false;
          window.getApp.showMessage(
            'Xóa xe thất bại, vui lòng thử lại',
            'error'
          );
        });
    },
    openShareVehicle () {
      this.$refs.shareVehicle.open();
    },

    openIntervalSendData () {
      this.$refs.intervalSendData.open(this.selectedVehicle);
    },

    async updateCutOffEngineData (val) {
      let data = {
        cutOffEngine: val,
        vehicleId: this.selectedVehicle.id
      };
      
      let res = await this.updateCutOffEngine(data).catch(_ => {
        return null;
      });

      if (!res) {
        window.getApp.showMessage('Thao tác thất bại.', 'error');
      }
      else { 
        window.getApp.showMessage('Thao tác thành công.', 'success');
        await this.getVehicles();
        // this.$parent
      }
    },

    showButton (button) {
      if (this.selectedVehicle.deviceType !== 'MTP8') {
        if (button.text === 'Tần suất gửi dữ liệu') return false;
      }
      return true;
    }
  }
};
</script>

<style scoped>
.statistic {
  margin: 4px 0px 0px 0px;
  color: grey;
}
.first {
  margin-top: 8px;
}
.block {
  margin-top: 8px;
}
.hr {
  margin-top: 12px;
}
.action-button {
  min-width: 200px;
}
.top {
  margin-top: 16px;
}

.switch-engine >>> .v-input--selection-controls__input{
  order: 2;
  margin-right: 0;
  margin-left: 12px;
}
.switch-engine >>> .v-label{
  font-size: 14px;
  color: grey;
}
.switch-engine >>> .v-messages{
  display: none;
}
.switch-engine >>> .v-input__slot{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/more.vue